import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  subHeading: {
    marginTop: theme.spacing(3),
  },
  card: {
    display: "flex",
    maxWidth: "536px",
    [theme.breakpoints.down("md")]: {
      padding: 0,
    },
  },
  cardContent: {
    padding: theme.spacing(2.5),
    paddingRight: 0,
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
      paddingRight: 0,
    },
  },
  divider: {
    width: "100%",
  },
  sponsorsDialogHeading: {
    fontSize: theme.typography.pxToRem(19),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.grey[800],
  },
  bankLogo: {
    width: 120,
    height: 90,
    margin: 2,
  },
}));

export default useStyles;
